/// <amd-module name="Artifacts/Cargo/commands/Restore" />
import { CargoActions } from "Artifacts/Cargo/redux";
import { getRestoreCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createRestoreCommand = getRestoreCommandCreator(CargoActions.restore);
